/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFeedbackSettings } from './taskFeedbackSettings';

export type TaskEvaluationConfigOutputFeedback = TaskFeedbackSettings | null;
